/* lystia-promo.js - промо-смуга FIRST10 (T-E2-12, parity/shell.md §1, A-038). Custom element <lystia-promo>.
   Стан Applied = прапорець localStorage `lystia:promo` (store key 'promo' = код) + подія document lystia:promo-change {code, applied}.
   Застосування: фоновий GET /discount/{код}?redirect=/cart (Shopify ставить cookie discount_code); без fetch - перехід за href.
   Applied: клік відкриває кошик (document.lystiaOverlay 'cart' або перехід на /cart). Тост - document.lystiaToast.
   A-142: після застосування смуга показує «застосовано» ~4 с і згортається (html.promo-collapsed => --promo-h: 0). Якщо код уже застосований
   при завантаженні - смуги немає (html.promo-collapsed ставить інлайн-скрипт у sections/promo-strip.liquid до рендеру, без стрибка).
   Скасування промокоду в кошику (promo-change applied=false / storage) - смуга повертається. */
(function () {
  'use strict';

  const ROOT = document.documentElement;
  const HIDE_MS = 4000;

  class LystiaPromo extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.code = this.dataset.code;
      this.btn = this.querySelector('[data-promo-btn]');
      this.text = this.querySelector('[data-promo-text]');
      this.chip = this.querySelector('[data-promo-code]');
      this.ok = this.querySelector('[data-promo-ok]');
      this.btn.addEventListener('click', (e) => this.onClick(e));
      this._off = document.lystia ? document.lystia.on('promo-change', () => this.render()) : null;
      this._onStorage = (e) => { if (e.key === 'lystia:promo') this.render(); };
      window.addEventListener('storage', this._onStorage);
      this.render();
      /* інлайн-скрипт уже згорнув смугу (код застосований до завантаження): прибираємо з потоку без анімації, анімацію вмикаємо після першого кадру */
      if (this.applied && ROOT.classList.contains('promo-collapsed')) {
        this.classList.add('is-gone');
        requestAnimationFrame(() => requestAnimationFrame(() => ROOT.classList.remove('promo-instant')));
      }
    }

    disconnectedCallback() {
      clearTimeout(this._hideT);
      clearTimeout(this._goneT);
      if (this._off) this._off();
      window.removeEventListener('storage', this._onStorage);
      this._init = false;
    }

    get applied() {
      const v = document.lystia ? document.lystia.store.get('promo', null) : null;
      return !!v && String(v).toUpperCase() === this.code.toUpperCase();
    }

    render() {
      const a = this.applied;
      this.classList.toggle('is-applied', a);
      this.text.textContent = a ? this.text.dataset.textApplied : this.text.dataset.textDefault;
      this.btn.setAttribute('aria-label', a ? this.btn.dataset.ariaApplied : this.btn.dataset.ariaDefault);
      this.chip.hidden = a;
      this.ok.hidden = !a;
      if (a) this.scheduleHide(); else this.show();
    }

    /* applied: показати «застосовано» кілька секунд, потім згорнути */
    scheduleHide() {
      if (ROOT.classList.contains('promo-collapsed') || this._hideT) return;
      this._hideT = setTimeout(() => { this._hideT = 0; if (this.applied) this.hide(); }, HIDE_MS);
    }

    hide() {
      ROOT.classList.add('promo-collapsed');
      clearTimeout(this._goneT);
      this._goneT = setTimeout(() => this.classList.add('is-gone'), 400);
    }

    /* промокод скасовано: повертаємо смугу */
    show() {
      clearTimeout(this._hideT); this._hideT = 0;
      clearTimeout(this._goneT);
      this.classList.remove('is-gone');
      ROOT.classList.remove('promo-instant');
      /* кадр на зняття visibility, потім анімація висоти */
      requestAnimationFrame(() => ROOT.classList.remove('promo-collapsed'));
    }

    openCart() {
      const ov = document.lystiaOverlay;
      if (ov && ov.has('cart')) ov.open('cart');
      else window.location.href = this.dataset.cartUrl;
    }

    onClick(e) {
      if (this.applied) { e.preventDefault(); this.openCart(); return; }
      if (!window.fetch) return; /* без fetch - звичайний перехід за href */
      e.preventDefault();
      fetch(this.btn.getAttribute('href'), { credentials: 'same-origin', redirect: 'manual' })
        .then(() => {
          if (document.lystia) {
            document.lystia.store.set('promo', this.code);
            document.lystia.emit('promo-change', { code: this.code, applied: true });
          }
          if (document.lystiaToast) document.lystiaToast.show(this.dataset.toast, { icon: 'check' });
        })
        .catch(() => { window.location.href = this.btn.getAttribute('href'); });
    }
  }

  if (!customElements.get('lystia-promo')) customElements.define('lystia-promo', LystiaPromo);
})();
